import { Session } from "./session";


export class SessionInits {
    constructor() {
        this.initMap();
    }

    initMap() {
        new Session();
    }
}
